import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-agricola-exit-confirm-dialog',
  templateUrl: './agricola-exit-confirm-dialog.component.html',
  styleUrls: ['./agricola-exit-confirm-dialog.component.css'],
  standalone: false
})
export class AgricolaExitConfirmDialogComponent {

  constructor(private dialogRef: MatDialogRef<AgricolaExitConfirmDialogComponent>) {}

  stay(): void {
    this.dialogRef.close(false);
  }

  leave(): void {
    this.dialogRef.close(true);
  }
}
